import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  useDeleteNotificationMutation,
  useGetAllNotificationTypesQuery,
  useGetAllNotificationsByProjectQuery,
  usePatchNotificationMutation,
  usePostNotificationMutation,
} from '@greenkub-fronts/data-access';
import { addSnackMessage } from '@greenkub-fronts/domain/snackbar';
import {
  AppDispatch,
  Notification,
  NotificationType,
} from '@greenkub-fronts/shared/interface';
import NotificationsModal from './notifications-modal';

export interface NotificationsModalFeatureProps {
  isOpen: boolean;
  onChangeIsOpen: any;
  projectId: string;
}

export function NotificationsModalFeature(
  props: NotificationsModalFeatureProps
) {
  const { isOpen, onChangeIsOpen, projectId } = props;

  const dispatch = useDispatch<AppDispatch>();

  const [mode, setMode] = useState<string>('read');
  const [notificationType, setNotificationType] =
    useState<NotificationType | null>(null);
  const [notificationContent, setNotificationContent] = useState<string>('');
  const [notificationTitle, setNotificationTitle] = useState<string>('');
  const [notificationId, setNotificationId] = useState<string>('');

  const { data: notifications = [] } = useGetAllNotificationsByProjectQuery({
    projectId,
  });

  const { data: notificationTypes = [] } = useGetAllNotificationTypesQuery();

  const [postNotification] = usePostNotificationMutation();
  const [deleteNotification] = useDeleteNotificationMutation();
  const [patchNotification] = usePatchNotificationMutation();

  useEffect(() => {
    if (notificationTypes.length > 0) {
      const newCurrentType = notificationTypes.find(
        (type: NotificationType) => type.slug === 'notification'
      );
      setNotificationType(newCurrentType);
    }
  }, [notificationTypes]);

  const openUpateNotification = (notifId: string) => {
    const currentNotif = notifications.find(
      (notif: Notification) => notif.id === notifId
    );
    setNotificationType(currentNotif.notificationType);
    setNotificationTitle(currentNotif.title);
    setNotificationContent(currentNotif.content);
    setNotificationId(currentNotif.id);
    setMode('update');
  };

  const expenseCard = (notifId: string) => {
    /**
     * Close all card except that one,
     */
  };

  const onTypeChange = (typeId: string) => {
    const newCurrent = notificationTypes.find(
      (type: NotificationType) => type.id === typeId
    );
    if (
      notificationType === null ||
      newCurrent.slug !== notificationType.slug
    ) {
      setNotificationType(newCurrent);
    }
  };

  const createNotificationHandler = () => {
    if (!notificationTitle || !notificationContent) {
      dispatch(
        addSnackMessage(
          'negative',
          'il manque le titre ou le contenu à votre notification'
        )
      );
      return;
    }
    postNotification({
      projectId,
      data: {
        title: notificationTitle,
        content: notificationContent,
        notificationTypeId: notificationType?.id,
      },
    });
    setMode('read');
  };

  const updateNotificationHandler = () => {
    patchNotification({
      notificationId,
      data: {
        title: notificationTitle,
        content: notificationContent,
        notificationTypeId: notificationType?.id,
      },
    });
    setMode('read');
  };

  const deleteNotificationHandler = (notifId: string) => {
    deleteNotification({ notificationId: notifId });
  };

  return (
    <NotificationsModal
      isOpen={isOpen}
      onChangeIsOpen={onChangeIsOpen}
      notifications={notifications}
      mode={mode}
      setMode={setMode}
      notificationType={notificationType}
      notificationTitle={notificationTitle}
      setNotificationTitle={setNotificationTitle}
      setNotificationContent={setNotificationContent}
      notificationContent={notificationContent}
      expenseCard={expenseCard}
      onTypeChange={onTypeChange}
      openUpateNotification={openUpateNotification}
      notificationTypes={notificationTypes}
      deleteNotificationHandler={deleteNotificationHandler}
      createNotificationHandler={createNotificationHandler}
      updateNotificationHandler={updateNotificationHandler}
    />
  );
}

export default NotificationsModalFeature;
